import { jsxs, jsx } from "react/jsx-runtime";
import { Inline, Box } from "braid-design-system";
import { bulletPointBase, selectedBackground, onReviewsPageUnselected } from "./BulletPoints.css.mjs";
const BulletPoints = ({
  focusedSlideIndex,
  moveSlidesLeft,
  moveSlidesRight,
  onReviewsLandingPage
}) => {
  const goToSlide = (event, slideIndex) => {
    if (slideIndex === focusedSlideIndex) {
      return;
    }
    const moveLeftOrRight = focusedSlideIndex - slideIndex;
    if (moveLeftOrRight > 0) {
      moveSlidesLeft(event, moveLeftOrRight);
    } else {
      moveSlidesRight(event, -moveLeftOrRight);
    }
  };
  const BulletPoint = ({ index }) => {
    const selected = focusedSlideIndex === index;
    return /* @__PURE__ */ jsx(
      Box,
      {
        component: "button",
        onClick: (event) => goToSlide(event, index),
        cursor: !selected ? "pointer" : void 0,
        background: selected ? void 0 : "neutralLight",
        className: [
          bulletPointBase,
          selected ? selectedBackground : void 0,
          !selected && onReviewsLandingPage ? onReviewsPageUnselected : void 0
        ],
        "aria-label": `Slide ${index + 1}`
      }
    );
  };
  return /* @__PURE__ */ jsxs(Inline, { space: "xsmall", align: "center", children: [
    /* @__PURE__ */ jsx(BulletPoint, { index: 0 }),
    /* @__PURE__ */ jsx(BulletPoint, { index: 1 }),
    /* @__PURE__ */ jsx(BulletPoint, { index: 2 })
  ] });
};
export {
  BulletPoints
};
